<template>
  <div class="resume">
    <h3>Professional Experience</h3>
    <hr>
    <table v-for="job in jobs" :key="job.id" style="margin: 0 60px 15px;">
      <tr>
        <td style="border: thin solid #C0C0C0; width: 140px">
          {{job.startDate}} - <br> {{job.endDate}}
        </td>
        <td style="border: thin solid #C0C0C0; width: 60%; text-align: left">
          <p><b>{{job.title}}</b></p>
          <i>{{job.employer}}</i> <br>
          {{job.location}}
        </td >
        <td style="border: thin solid #C0C0C0; width: 20%">
          <b-img :src="require('@/assets/pictures/' + job.picture)" alt="Job logo"></b-img>
        </td>
      </tr>
      <tr>
        <td>
        </td>
        <td colspan="2" style="text-align:left">
            <transition name="fade" mode="out-in">
              <div v-if="readMore[job.id-1]" key="yes">
                <span v-html="job.description" class="more"></span>
                <a class="readbtn" href="#!" @click="expandJobs(job.id-1)" >
                  Read less
                </a>
              </div>
              <div v-else key="no">
                <a class="readbtn" href="#readmore" @click="expandJobs(job.id-1)" >
                  Read description
                </a>
              </div>
            </transition>
        </td>
      </tr>
    </table>
    <h3>Academic Background</h3>
    <hr>
    <table style="margin: 0 60px 15px;">
      <tr>
        <td style="border: thin solid #C0C0C0; width: 140px">
            September 2014 - May 2018
        </td>
        <td style="border: thin solid #C0C0C0; width: 60%; text-align: left">
          <p><b>New York Institute of Technology</b></p>
          <i>Bachelor’s in Electrical and Computer Engineering</i> <br>
          GPA: 3.74
        </td >
        <td style="border: thin solid #C0C0C0;">
          <b-img :src="require('@/assets/pictures/nyit.png')" alt="School logo"></b-img>
        </td>
      </tr>
      <tr>
        <td>
        </td>
        <td colspan="2" style="text-align: left">
          Accomplishments: <br>
          <ul>
            <li>Dean's’ List (2014 – 2018)</li>
            <li>President’s Honor Roll (2014 – 2018)</li>
            <li>NYIT Athletic Director’s Honor Roll (2014 – 2018)</li>
            <li>Full Scholarship (2014 – 2018)</li>
          </ul>
          <h5>Collegiate Athletics</h5>
          <div>      
            <i>NYIT Men’s Basketball Team | Captain</i><br>
            <ul>
              <li>Received full scholarship</li>
              <li>Gained valuable leadership, team-building and time management experience</li>
            </ul>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Resume',
  data() {
    return {
      readMore: [],
      jobs: [
        {
          id: 1,
          title: "Quality Engineer",
          employer: "Google (via Qualitest LLC)",
          startDate: "July 2018",
          endDate: "March 2020",
          location: "New York, NY",
          description: "<i>Primary Work:</i><br> \
            <ul><li>In charge of the Norwegian localization of several features for the Google Search, Google Maps, and Google Assistant platforms</li> \
            <li>Used complex SQL queries against Google’s internal relational database to create and debug language models and recall sets</li> \
            <li>Guaranteed quality assurance with meticulous iterative-, comparison-, end-to-end-,  and regression testing</li></ul> \
            <i>Programming/development:</i><br> \
            <ul><li>Significantly simplified coworkers’ workflow by developing and maintaining automation scripts using Bash, C++ and Java</li> \
            <li>Incorporated a script supplier/repository to ensure that the most up to date version of all automation scripts were executed</li> \
            <li>Updated and maintained the team’s designated gLinux servers</li></ul> \
            <i>Training/onboarding:</i><br> \
            <ul><li>Trained and mentored new employees, getting them into the regular workflow 30% faster than the estimated schedule</li> \
            <li>Traveled to Lisbon, Portugal to provide training for a newly established team regarding the scope and development of new and existing products</li></ul>",
          picture: "google.png"
        },
        {
          id: 2,
          title: "Logistic Coordinator",
          employer: "Møller Logistics",
          startDate: "May 2014",
          endDate: "August 2016",
          location: "Lillestrøm, Norway",
          description: "<ul><li>Implemented a new database system for all goods and wares</li> \
            <li>Organized, stocked and shipped wares</li></ul>",
          picture: "moller.png"
        },
        {
          id: 3,
          title: "Shift Leader",
          employer: "McDonald's",
          startDate: "March 2010",
          endDate: "September 2012",
          location: "Oslo, Norway",
          description: "<ul><li>Managed customer complaints and responses</li> \
            <li>Supervised daily managerial tasks</li></ul>",
          picture: "mcdonalds.png"
        }
      ]
    }
  },
  methods: {
    expandJobs(aInt) {
      this.readMore[aInt] =! this.readMore[aInt];
      this.readMore = [...this.readMore];
    }
  }
}
</script>

<style scoped>
.resume {
    background: white;
    border-radius: 10px;
  }

.fade-enter-active, 
.fade-leave-active {
  transition: all 1s ease;
  max-height: 500px;
  overflow: hidden;
}

.fade-enter,
.fade-leave-to {
  max-height: 0px;
}


.readbtn {
  font-style: italic;
  padding-right: 10px;
  float: right;
}

.more >>> ul {
  margin-bottom: 0;
  list-style-type: square;
}

</style>
